import { clientOnlyLazy } from 'components/ClientOnlySuspense/clientOnlyLazy';
import LoadingModal from 'modals/LoadingModal';

export const ShareNewListingModalLoadable = clientOnlyLazy({
  loader: () =>
    import(
      /* webpackChunkName: "ShareNewListingModal" */
      './ShareNewListingModal.dynamic'
    ),
  loading: LoadingModal,
});
